"use strict";

angular.module('rmToken')
	.controller('TokenOverviewCtrl', require('./token_overview_ctrl'));
